module.exports = __webpack_public_path__ + "img/deamaya.80466a7b.jpg";